/*
 * @Description: Onchain Project
 * @Version: 1.0.0
 * @Author: EricYangc
 */
export enum FormLayoutType {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Inline = 'inline'
}
